/* eslint-disable */
import { partnerMemberStatusOptions } from '../constants/AppConstant';
import { errorMsg } from '../constants/messages';

const partnerOrdersFormData = [
  {
    name: 'groupCode',
    label: 'Order Code',
    fieldType: {
      name: 'text',
    },
    required: true,
    errorMsg: errorMsg,
    tableMeta: { title: 'Order Id', allowAddRecordClick: true },
    isTableHeader: true,
    isAccordian: false,
    readonly: true,
    default: '',
  },
  {
    name: 'companyName',
    label: 'Company Name',
    fieldType: {
      name: 'text',
    },
    required: true,
    errorMsg: errorMsg,
    tableMeta: { title: 'Company Name' },
    isTableHeader: true,
    isAccordian: false,
    default: '',
  },
  // {
  //   name: 'planType',
  //   label: 'Plan',
  //   fieldType: {
  //     name: 'text',
  //   },
  //   required: false,
  //   readonly: true,
  //   errorMsg: errorMsg,
  //   tableMeta: { title: 'Plan', columnType: 'planType' },
  //   isTableHeader: true,
  //   isAccordian: false,
  //   default: '',
  // },
  {
    name: 'partnerCompany',
    label: 'Agent Name',
    fieldType: {
      name: 'text',
    },
    required: true,
    errorMsg: errorMsg,
    tableMeta: { title: 'Agent Name' },
    isTableHeader: true,
    isAccordian: false, // Hide from accordion view
    default: '',
  },
  {
    name: 'partnerEmail',
    label: 'Agent Email',
    fieldType: {
      name: 'text',
    },
    required: false,
    errorMsg: errorMsg,
    tableMeta: { title: 'Agent Email' },
    isTableHeader: true,
    isAccordian: false,
    default: '',
  },
  {
    name: 'partnerPackage',
    label: 'Service Name',
    fieldType: {
      name: 'text',
    },
    required: true,
    errorMsg: errorMsg,
    tableMeta: {
      title: 'Service Name',
      columnType: 'partnerService',
    },
    isTableHeader: true,
    isAccordian: false,
    default: '',
  },
  {
    name: 'memberNames',
    label: 'Member Names',
    fieldType: {
      name: 'text',
    },
    required: false,
    errorMsg: errorMsg,
    tableMeta: { title: 'Member Names', columnType: 'memberNames', allowAddRecordClick: true },
    isTableHeader: true,
    isAccordian: false,
    hideFromAbstractForm: true,
    default: '',
  },
  {
    name: 'memberStatus',
    label: 'Application Status',
    fieldType: {
      name: 'select',
      options: partnerMemberStatusOptions,
    },
    required: true,
    errorMsg: errorMsg,
    tableMeta: { title: 'Application Status', columnType: 'memberStatus' },
    isTableHeader: true,
    isAccordian: false,
    default: '',
  },

  {
    name: 'status',
    label: 'Status',
    fieldType: {
      name: 'select',
      options: [
        { value: 'active', name: 'Active' },
        { value: 'application-created', name: 'Application Created' },
        { value: 'form filling under process', name: 'Form Filling Under Process' },
        { value: 'form filled review pending', name: 'Form Filled Review Pending' },
        { value: 'submitted', name: 'Submitted' },
        { value: 'under review', name: 'Under Review' },
        { value: 'processing', name: 'Processing' },
        { value: 'additional-information', name: 'Additional Information' },
        { value: 'completed', name: 'Completed' },
        { value: 'inactive', name: 'Inactive' },
      ],
    },
    required: true,
    errorMsg: errorMsg,
    tableMeta: { title: 'Status' },
    isTableHeader: false,
    isAccordian: false,
    default: '',
  },
  {
    name: 'trackingId',
    label: 'Tracking Id',
    fieldType: {
      name: 'text',
    },
    required: false,
    errorMsg: errorMsg,
    tableMeta: { title: 'Tracking Id', allowAddRecordClick: false },
    isTableHeader: false,
    isAccordian: false,
    default: '',
  },
  {
    name: 'createdAt',
    label: 'Date of Creation',
    fieldType: {
      name: 'date',
    },
    required: false,
    errorMsg: errorMsg,
    tableMeta: { title: 'Order Date', columnType: 'registrationDate' },
    isTableHeader: true,
    isAccordian: false,
    default: '',
  },
  {
    name: 'review',
    label: 'Details',
    fieldType: {
      name: 'reviewPartnerOrder',
    },
    required: false,
    errorMsg: errorMsg,
    tableMeta: { title: 'Details', columnType: 'clickHere', allowAddRecordClick: false },
    isTableHeader: false,
    isAccordian: true,
    preserveAccordionStyles: true,
    default: '',
  },
];

export { partnerOrdersFormData };
